module.exports = __webpack_public_path__ + "static/media/carousel-4.050ab61f.png";